import * as React from 'react';
import { Avatar, Badge } from 'react-native-paper';
import { View, StyleSheet, Pressable } from 'react-native';
import { generateInitials } from '../../services/Utils';
import { useNotifications } from '../../providers/NotificationProvider';
import { LinearGradient } from 'expo-linear-gradient';

export interface IUserAvatar {
    displayName: string;
    size?: number;
    showBadge?: boolean;
    imageUrl?: string;
}

const UserAvatar: React.FC<IUserAvatar> = ({
    displayName,
    size = 40,
    showBadge = false,
    imageUrl
}) => {
    const { unreadCount } = useNotifications();

    const initials = generateInitials(displayName || 'User');
    const badgeSize = size * 0.45;

    return (
        <View style={styles.container}>
            <View style={[styles.avatarOuterRing, { width: size + 6, height: size + 6, borderRadius: (size + 6) / 2 }]}>
                {imageUrl ? (
                    <Avatar.Image 
                        source={{ uri: imageUrl }} 
                        size={size} 
                        style={styles.avatarImage} 
                    />
                ) : (
                    <LinearGradient
                        colors={['#102B27', '#1D4C43', '#4BB75F']}
                        start={{ x: 0, y: 0 }}
                        end={{ x: 1, y: 1 }}
                        style={[styles.gradientBg, { width: size, height: size, borderRadius: size / 2 }]}
                    >
                        <Avatar.Text
                            style={styles.avatarText}
                            size={size}
                            label={initials}
                            labelStyle={[styles.label, { fontSize: size * 0.4, lineHeight: size }]}
                        />
                    </LinearGradient>
                )}
            </View>
            
            {showBadge && unreadCount > 0 && (
                <Badge
                    size={badgeSize}
                    style={[
                        styles.badge,
                        {
                            top: -2,
                            right: -2,
                            backgroundColor: '#BA1A1A',
                            fontSize: badgeSize * 0.7,
                            lineHeight: badgeSize,
                            fontWeight: '700'
                        }
                    ]}
                >
                    {unreadCount}
                </Badge>
            )}
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        position: 'relative',
        justifyContent: 'center',
        alignItems: 'center',
    },
    avatarOuterRing: {
        borderWidth: 2,
        borderColor: 'rgba(255, 255, 255, 0.85)',
        backgroundColor: '#102B27',
        justifyContent: 'center',
        alignItems: 'center',
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 3,
        },
        shadowOpacity: 0.3,
        shadowRadius: 4.65,
        elevation: 6,
    },
    gradientBg: {
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
    },
    avatarText: {
        backgroundColor: 'transparent',
    },
    avatarImage: {
        backgroundColor: '#102B27',
    },
    label: {
        color: '#FFFFFF',
        fontWeight: '700',
        letterSpacing: 0.5,
    },
    badge: {
        position: 'absolute',
        borderWidth: 1.5,
        borderColor: '#FFFFFF',
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 1,
        },
        shadowOpacity: 0.2,
        shadowRadius: 1.41,
        elevation: 2,
    }
});

export default UserAvatar;